// src/types/registration.ts

/**
 * 代理店セルフ登録フォームの型定義
 */

/**
 * ヒーロー動画のプリセット（6種類）
 */
export const HERO_VIDEO_OPTIONS = [
  { value: 'mv_sp', label: '動画1（デフォルト）' },
  { value: 'mv_video1', label: '動画2' },
  { value: 'mv_video2', label: '動画3' },
  { value: 'mv_video3', label: '動画4' },
  { value: 'mv_video4', label: '動画5' },
  { value: 'mv_video5', label: '動画6' },
] as const;

export type HeroVideoKey = (typeof HERO_VIDEO_OPTIONS)[number]['value'];

/**
 * ビジョン画像のプリセット（6種類）
 */
export const VISION_IMAGE_OPTIONS = [
  { value: 'vision_image1', label: '画像1（デフォルト）' },
  { value: 'vision_image2', label: '画像2' },
  { value: 'vision_image3', label: '画像3' },
  { value: 'vision_image4', label: '画像4' },
  { value: 'vision_image5', label: '画像5' },
  { value: 'vision_image6', label: '画像6' },
] as const;

export type VisionImageKey = (typeof VISION_IMAGE_OPTIONS)[number]['value'];

/**
 * 基本情報（Step 1）
 */
export interface BasicInfo {
  agencyId: string; // 代理店ID
  agencyName: string; // 名前
  email: string; // メールアドレス
  phone?: string; // 電話番号（任意）
}

/**
 * LPカスタマイズ（Step 2）
 */
export interface LpCustomize {
  // ヒーローセクション
  heroVideoKey: HeroVideoKey; // 動画選択（6種類から）
  heroTitle: string; // タイトル

  // ビジョンセクション
  visionImageKey: VisionImageKey; // 画像選択（5種類から）
}

/**
 * プロフィール（Step 3）
 */
export interface ProfileInfo {
  name: string; // 名前
  bio: string; // 紹介文
  photoUrl?: string; // プロフィール画像URL
  socialLinks: {
    instagram?: string; // Instagram URL
    twitter?: string; // X (Twitter) URL
    youtube?: string; // YouTube URL
  };
}

/**
 * ブランディング（Step 4）
 */
export interface BrandingInfo {
  primaryColor?: string; // プライマリカラー
  lineUrl?: string; // LINEリンクURL
  applicationUrl?: string; // 申し込みフォームURL
}

/**
 * 登録フォーム全体のデータ
 */
export interface RegistrationFormData {
  basicInfo: BasicInfo;
  lpCustomize: LpCustomize;
  profile: ProfileInfo;
  branding: BrandingInfo;
}

/**
 * Cloud Function レスポンス型
 */
export interface RegisterAgencyResponse {
  success: boolean;
  agencyId?: string;
  shortTokenId?: string;
  urls?: {
    lp: string;
    simulator: string;
  };
  error?: string;
}

/**
 * デフォルト値
 */
export const DEFAULT_VALUES: RegistrationFormData = {
  basicInfo: {
    agencyId: '',
    agencyName: '',
    email: '',
    phone: '',
  },
  lpCustomize: {
    heroVideoKey: 'mv_sp',
    heroTitle: '人生は選択で変えられる',
    visionImageKey: 'vision_image1',
  },
  profile: {
    name: '山田 太郎',
    bio: `株式会社〇〇

保険業界での長年の経験を活かし、お客様一人ひとりに最適な保障プランをご提案しています。

「人生は選択で変えられる」という信念のもと、複雑な保険の仕組みをわかりやすくお伝えし、お客様が安心して未来を設計できるようサポートすることを使命としています。`,
    photoUrl: '',
    socialLinks: {
      instagram: '',
      twitter: '',
      youtube: '',
    },
  },
  branding: {
    primaryColor: '#f1ac2c',
    lineUrl: '',
    applicationUrl: '',
  },
};
